// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__26ctf","question":"Question_question__2PRcb","description":"Question_description__3LLrL"};